import React from "react";
import PartnerTable from "./List/PartnerList";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Team = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <PartnerTable/>
      </div>
    </div>
  );
};

export default Team;
